var map = {
	"./diamond-color-1@3x.png": 67,
	"./diamond-color-2@3x.png": 69,
	"./diamond-color-3@3x.png": 71,
	"./diamond-color-4@3x.png": 73,
	"./diamond-color-5@3x.png": 75,
	"./diamond-color-table@3x.png": 77,
	"./diamond-color-table_over-md@3x.png": 79
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 254;